import { render, staticRenderFns } from "./LicenseDescription.vue?vue&type=template&id=e7576c2c&scoped=true"
import script from "./LicenseDescription.vue?vue&type=script&lang=ts"
export * from "./LicenseDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7576c2c",
  null
  
)

export default component.exports